exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".pad___P6ndh {\n  padding: 30px; }\n  .pad___P6ndh.empty___1Uq-y {\n    padding-top: 0; }\n", "", {"version":3,"sources":["/Users/fdev/code/factorial/factorial-components/src/components/Modal/Pad/src/components/Modal/Pad/index.scss"],"names":[],"mappings":"AAAA;EACE,cAAa,EAKd;EAND;IAII,eAAc,EACf","file":"index.scss","sourcesContent":[".pad {\n  padding: 30px;\n\n  &.empty {\n    padding-top: 0;\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"pad": "pad___P6ndh",
	"empty": "empty___1Uq-y"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./~/sass-loader/lib/loader.js?{"includePaths":["/Users/fdev/code/factorial/factorial-components/styles"],"sourceMap":true}!./~/postcss-loader/lib?{"path":"/Users/fdev/code/factorial/factorial-components/webpack/postcss.config.js"}!./src/components/Modal/Pad/index.scss
// module id = 101
// module chunks = 0